// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"450":"lang-fr-js","822":"lang-messages-js"}[chunkId] + "-legacy." + {"450":"64a264d0","822":"b0ad1d17"}[chunkId] + ".js";
};